import {useEffect, useState} from 'react';
import {useCookies} from "react-cookie";

function useTenants() {
    const [tenants, setTenants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const fetchTenantPage = async (page) => {
        const response = await fetch(`${apiRoot}/backoffice/tenants?page=${page}&size=100&includeDeleted=true`, {headers: apiHeaders});
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    };

    const getTenants = async () => {
        try {
            setLoading(true);
            const firstPageData = await fetchTenantPage(0);
            const totalPages = firstPageData.totalPages;
            let allPagesData = [...firstPageData.content];

            const fetchPromises = [];
            for (let i = 1; i < totalPages; i++) {
                fetchPromises.push(fetchTenantPage(i));
            }

            const results = await Promise.all(fetchPromises);
            results.forEach((pageData) => {
                allPagesData = allPagesData.concat(pageData.content);
            });
            setTenants(allPagesData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getTenants();
    }, []);

    return {tenants, setTenants, getTenants, loading, setLoading, error, setError};
}

export default useTenants;
